import { LocalizationService, SessionStateService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'hyyak';

  constructor(
    private router: Router,
    private sessionState: SessionStateService,
    private localizationService: LocalizationService,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit(): void {  
  }
}
